import { io } from "socket.io-client";

let socket = null;

/**
 * FIX: the old config had `reconnectionAttempts: 5`. Once socket.io
 * used up those 5 attempts (a normal thing on flaky wifi, a phone
 * locking, or the server restarting) it gave up PERMANENTLY. That was
 * the actual cause of "socket randomly disconnects and never comes
 * back" — it wasn't random at all, it just stopped retrying silently.
 * Removing the cap (or setting it very high) lets it keep trying with
 * its built-in backoff.
 */
export const connectSocket = (token) => {
  if (socket?.connected) return socket;

  // FIX: previously, calling connectSocket() again while an old,
  // half-broken socket still existed (but wasn't `.connected`) just
  // created a brand new io() instance on top of it — leaking the old
  // connection and its listeners. Always clean up first.
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  const baseUrl = (process.env.REACT_APP_API_URL || "").replace("/api", "") || "http://localhost:5036";

  socket = io(baseUrl, {
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity, // keep trying — don't give up on the user
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    timeout: 20000,
    auth: { token },
    autoConnect: true,
    withCredentials: true,
    path: "/socket.io",
  });

  socket.on("connect", () => {
    console.log("✅ Socket connected:", socket.id);
  });

  socket.on("disconnect", (reason) => {
    console.log("❌ Socket disconnected:", reason);
    // "io server disconnect" means the server forcibly kicked us
    // (e.g. it explicitly called socket.disconnect()) — the client
    // won't auto-reconnect in that one case, so kick it manually.
    if (reason === "io server disconnect") {
      socket.connect();
    }
  });

  socket.on("connect_error", (err) => {
    console.warn("⚠️ Socket connect error:", err.message);
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
};

/**
 * FIX: browsers throttle/suspend background tabs, which can silently
 * drop the websocket without ever firing a normal "offline" event.
 * Re-checking on tab focus and on the browser's online event catches
 * that case and reconnects immediately instead of waiting for the
 * next backoff cycle (or forever, under the old 5-attempt cap).
 */
export const attachRecoveryListeners = () => {
  const tryReconnect = () => {
    if (socket && !socket.connected) {
      socket.connect();
    }
  };

  window.addEventListener("online", tryReconnect);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") tryReconnect();
  });

  return () => {
    window.removeEventListener("online", tryReconnect);
  };
};